import { useState } from "react";
import Simple from "../../../Components/InputFields/Simple";
import GradientBlue from "../../../Components/InputFields/GradientBlue";
import LogoWhite10 from "../../../Media/PNG/LogoWhite10.svg";
import LogoBlue from "../../../Media/PNG/LogoBlue.svg";
import Back from "./Back";

export default function ContainerForgotPWEmail({ text, onContinue, onBack }) {
  const logoSrc = document.documentElement.classList.contains("dark")
    ? LogoWhite10
    : LogoBlue;
  const [email, setEmail] = useState("");
  const [emailRequired, setEmailRequired] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (email.trim() === "") {
      setEmailRequired(true);
      return;
    }
    onContinue(email.trim());
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
    setEmailRequired(false);
  };

  return (
    <div className="w-full max-w-sm bg-zi-bg2-light dark:bg-zi-inputbg-dark/50 rounded-3xl p-5 gap-7 flex flex-col">
      <div className="flex flex-col gap-2 justify-center items-center">
        <div className="h-14">
          <img src={logoSrc} alt="لوگو" className="w-14" />
        </div>
        <p className="font-medium text-sm text-zi-text-light dark:text-zi-text-dark">
          کوژیتو فاند
        </p>
      </div>
      <div className="flex items-center justify-between gap-3">
        <h1 className="text-lg font-medium text-zi-text-light dark:text-zi-text-dark">
          {text}
        </h1>
        <Back onClick={onBack}/>
      </div>
      <div>
        <form className="flex flex-col gap-5" onSubmit={handleSubmit}>
          <Simple
            placeholder="آدرس ایمیل"
            type="email"
            id="forgot-password-email"
            formValue={email}
            formOnChange={handleEmailChange}
          />
          <GradientBlue type="submit" value="ارسال کد از طریق ایمیل" />
        </form>
        {emailRequired && (
          <p className="text-amber-400 text-sm font-extralight mt-1">
            لطفا ایمیل خود را وارد کنید
          </p>
        )}
      </div>
    </div>
  );
}
